<template>
  <div class="w-100 p-0 position-relative d-flex flex-column">
    <div class="row m-0">
      <div class="col" :class="{ 'tab-border': isSelectTextTab() }" @click="clickTabText">
        <div class="menu-tab-text">テキスト</div>
      </div>
      <div class="col" :class="{ 'tab-border': isSelectQRTab() }" @click="clickTabQR">
        <div class="menu-tab-text">二次元コード</div>
      </div>
    </div>

    <!-- 境界線 -->
    <div class="line" />

    <div style="height:calc(100vh - 122px);">
      <!-- 個別編集モード -->
      <div v-if="isIndividualEditMode()" class="d-flex flex-column h-100">
        <div v-if="this.isProduct()" style="height:calc(100vh - 326px);" >
          <div class="item-scroll h-100 scrollbar" v-if="isSelectTextTab()">
            <TextEditItem
              v-for="item in this.getTextItemList()"
              v-bind:itemData="item"
              v-bind:key="item.itemId"
            />
          </div>
          <div class="item-scroll h-100 scrollbar" v-if="isSelectQRTab()">
            <QREditItem
              v-for="item in this.getQRItemList()"
              v-bind:itemData="item"
              v-bind:key="item.itemId"
            />
          </div>
        </div>

        <!-- テキスト追加 -->
        <div class="d-flex align-items-center justify-content-center py-2 position-relative" :class="{'feature-ui':this.$store.state.tutorial.isShowEdit && this.$store.state.tutorial.editStep == 1}" style="height: 56px;">
          <form onsubmit="return false;" class="">
            <input type="text" class="input-text addtext" id="text" v-model="textData" v-bind="{placeholder:getAddTextPlaceholder}" />
          </form>
          <button @click="addText" class="bg-transparent border-0 text-primary fs-4 input-text-icon">
            <i class="bi bi-plus-circle" style="color:#8C9BC6"></i>
          </button>
        </div>

        <hr class="mt-1 mb-2" style="height: 2px;">

        <div style="height:145px;">
          <button @click="browserEdit" class="acry-btn-secondary-normal btn-size mb-2">一括編集</button>
          <button @click="saveDraft" class="acry-btn-secondary-normal btn-size mb-2">下書き保存</button>
          <button @click="addCart" class="acry-btn-cartin btn-size mb-2">カートに入れる</button>
        </div>
      </div>

      <!-- 一括編集モード -->
      <div class="mx-2 h-100" v-if="isListEditMode()">
        <div class="row" v-if="isSelectTextTab()" style="height:56px;">
          <div class="col position-relative">
            <select
              class="form-select"
              v-model="selectTextItemName"
            >
              <option disabled value="default">選択してください</option>
              <option v-for="item in this.getTextItemList()" v-bind:key="item.itemId">
                {{ item.itemName }}
              </option>
            </select>
            <div class="select-icon"></div>
          </div>
        </div>
        <div class="row" v-if="isSelectQRTab()" style="height:56px;">
          <div class="col position-relative">
            <select
              class="form-select"
              v-model="selectQRItemName"
            >
              <option disabled value="default">選択してください</option>
              <option v-for="item in this.getQRItemList()" v-bind:key="item.itemId">
                {{ item.itemName }}
              </option>
            </select>
            <div class="select-icon"></div>
          </div>
        </div>

        <div v-if="this.isProduct()">
          <div class="list-scroll scrollbar" v-if="isSelectTextTab()" style="height:calc(100vh - 325px);">
            <div
              v-for="(item, index) in getCurrentTextItemTextArray"
              v-bind:key="index"
              class=""
            >
              <form onsubmit="return false;">
                <input
                  type="text"
                  class="form-control"
                  id="text"
                  v-bind="{placeholder:index+1}"
                  v-model="getCurrentTextItemTextArray[index]"
                />
              </form>
            </div>
          </div>
          <div class="list-scroll scrollbar" v-if="isSelectQRTab()" style="height:calc(100vh - 325px);">
            <div v-for="(item, index) in getCurrentQRItemTextArray" v-bind:key="index">
              <form onsubmit="return false;">
                <input
                  type="text"
                  class="form-control"
                  id="text"
                  v-bind="{placeholder:index+1}"
                  v-model="getCurrentQRItemTextArray[index]"
                />
              </form>
            </div>
          </div>
        </div>

        <hr class="mt-1 mb-2" style="height: 2px;">

        <div style="height:145px;">
          <button @click="endBrowserEdit" class="acry-btn-secondary-normal btn-size mb-2">個別編集</button>
          <button @click="saveDraft" class="acry-btn-secondary-normal btn-size mb-2">下書き保存</button>
          <button @click="addCart" class="acry-btn-cartin btn-size mb-2">カートに入れる</button>
        </div>

      </div>
    </div>

    <!-- チュートリアル用1 -->
    <div class="tutorial-modal p-4" style="height:190px; top:590px;"
    v-if="this.$store.state.tutorial.isShowEdit && this.$store.state.tutorial.editStep == 1">
      <p class="text-start fw-bold">テキスト・二次元コード追加</p>
      <p class="text-start mt-4">ここからテキストを追加してください。</p>
      <button class="acry-btn position-absolute" style="width:105px; height:40px; border-radius: 40px; rihgt:10px; right: 18px;"
      @click="tutorialNextStep()">
        OK
      </button>
      <!-- 吹き出し -->
      <div class="position-absolute" style="right:-15px; top:100px;">
        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="32" viewBox="0 0 34 32" fill="none">
        <path d="M33.1075 15.0974C33.8669 15.4596 33.8669 16.5404 33.1075 16.9026L1.93048 31.7722C1.26683 32.0888 0.499998 31.6049 0.499999 30.8696L0.5 1.13037C0.5 0.395104 1.26683 -0.0887492 1.93048 0.227774L33.1075 15.0974Z" fill="white"/>
        </svg>
      </div>
    </div>

    <!-- チュートリアル用2 -->
    <div class="tutorial-modal p-4" style="height:190px; top:-60px;"
    v-if="this.$store.state.tutorial.isShowEdit && this.$store.state.tutorial.editStep == 2">
      <p class="text-start fw-bold">カート</p>
      <p class="text-start mt-4">ここでカートの中身の確認とお会計を行うことができます。</p>
      <button class="acry-btn position-absolute" style="width:105px; height:40px; border-radius: 40px; rihgt:10px; right: 18px;"
      @click="tutorialNextStep()">
        OK
      </button>
      <!-- 吹き出し -->
      <div class="position-absolute" style="right:-15px; top:20px;">
        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="32" viewBox="0 0 34 32" fill="none">
        <path d="M33.1075 15.0974C33.8669 15.4596 33.8669 16.5404 33.1075 16.9026L1.93048 31.7722C1.26683 32.0888 0.499998 31.6049 0.499999 30.8696L0.5 1.13037C0.5 0.395104 1.26683 -0.0887492 1.93048 0.227774L33.1075 15.0974Z" fill="white"/>
        </svg>
      </div>
    </div>

  </div>
</template>

<script>
import TextEditItem from "@/components/acyrpro/TextEditItem_Ap.vue";
import QREditItem from "@/components/acyrpro/QREditItem_Ap.vue";
import { CSV } from "@/js/CSV_EditData.js";
import { CenterViewState, RightViewState, GetAcryProductPrice, GetAcryProductSizeText } from "@/js/Const.js";
import VueCookies from "vue-cookies";
import { Analytics } from "@/js/Analytics.js";
import { Big } from 'big.js';
import { DiscountRatio } from "@/js/CommonFunc.js";

export default {
  name: "RightMenuEdit_Ap",
  props: {},
  data: function () {
    return {
      isSelectTabText: true, // 現在選択中のタブ
      textData: "",
      selectTextItemName: "default",
      selectQRItemName: "default",
    };
  },
  computed: {
    getCurrentTextItemTextArray() {
      if (this.selectTextItemName == "") return [];
      for (var i = 0; i < this.$store.state.currentCanvasData.itemList.length; i++) {
        if (
          this.selectTextItemName ==
          this.$store.state.currentCanvasData.itemList[i].itemName
        ) {
          return this.$store.state.currentCanvasData.itemList[i].textArray;
        }
      }
      return null;
    },
    getCurrentQRItemTextArray() {
      if (this.selectQRItemName == "") return [];
      for (var i = 0; i < this.$store.state.currentCanvasData.itemList.length; i++) {
        if (
          this.selectQRItemName ==
          this.$store.state.currentCanvasData.itemList[i].itemName
        ) {
          return this.$store.state.currentCanvasData.itemList[i].textArray;
        }
      }
      return null;
    },
    quantity() {
      return this.$store.state.currentProduct.quantity;
    },
    editedNum() {
      if (this.$store.state.currentCanvasData) {
        const itemList = Array.from({ length: this.quantity }, () => 1);
        // 未編集をカウントしていく
        for (const item of this.$store.state.currentCanvasData.itemList.slice()) {
          for (let i = 0; i < this.quantity; ++i) {
            if (item.textArray[i] == "") {
              itemList[i] = 0;
            }
          }
        }

        return itemList.filter((item) => item == 1).length;
      }

      return 0;
    },
    getAddTextPlaceholder(){
      return this.isSelectTextTab()?"テキストを追加":"URLを追加";
    }
  },
  created: function () {
    this.$store.commit("setListEditMode", false);

    let isTutorial = VueCookies.get("t_e");
    if( !isTutorial ){
      this.isFirstTutorial = true;

      VueCookies.set("t_e", true, '1y');

      // チュートリアル開始
      this.$store.commit("showEditTutorial");
    }

  },
  components: {
    TextEditItem,
    QREditItem,
  },
  methods: {
    // ===== タブ周り ===== //
    clickTabText() {
      if (this.isIndividualEditMode()) {
        // 個別編集モード
        this.isSelectTabText = true;
      } else {
        // 一括編集
        if (this.getTextItemList()[0]) {
          this.selectTextItemName = this.getTextItemList()[0].itemName;
        }
        if (this.getQRItemList()[0]) {
          this.selectQRItemName = this.getQRItemList()[0].itemName;
        }
        this.isSelectTabText = true;
      }
    },
    clickTabQR() {
      this.isSelectTabText = false;
    },
    isSelectTextTab() {
      return this.isSelectTabText;
    },
    isSelectQRTab() {
      return !this.isSelectTabText;
    },
    listPreview (){
        this.$store.commit("showListPreview");
    },
    // 編集モード
    isIndividualEditMode() {
      return !this.$store.state.isListEditMode;
    },

    isListEditMode() {
      return this.$store.state.isListEditMode;
    },

    // ===== タブ周り ===== //
    isProduct() {
      return this.$store.state.currentProduct;
    },

    getTextItemList: function () {
      if (this.$store.state.currentCanvasData) {
        const itemList = [];
        for (const item of this.$store.state.currentCanvasData.itemList.slice()) {
          if (item.itemType == "Text") {
            itemList.push(item);
          }
        }
        return itemList;
      } else {
        return [];
      }
    },
    getQRItemList: function () {
      if (this.$store.state.currentCanvasData) {
        const itemList = [];
        for (const item of this.$store.state.currentCanvasData.itemList.slice()) {
          if (item.itemType == "QR") {
            itemList.push(item);
          }
        }
        return itemList;
      } else {
        return [];
      }
    },

    addText() {
      if (!this.$store.state.currentCanvasData) {
        return;
      }

      if (this.textData == "") {
        this.$store.commit("showMessage", "テキストを入力してください");
        return;
      }

      // アイテム名の設定
      const Count = this.getTextItemList().length;
      var itemName = "";
      var i = 1;
      do {
        itemName = (this.isSelectTextTab() ? "TextItem_" : "CodeItem_") + (Count + i++);
      } while (
        this.$store.state.currentCanvasData.itemList
          .slice()
          .filter((item) => item.itemName == itemName).length
      );

      let textArray = Array.from({ length: this.quantity }, () => "");
      textArray[this.$store.state.currentSelectPlateNo] = this.textData;

      if (this.isSelectTextTab()) {
        this.$store.state.currentCanvasData.addTextItem(
          textArray,
          "AnitoStd-M",
          "center",
          "#000000",
          itemName
        );
      } else {
        this.$store.state.currentCanvasData.addQRItem(
          textArray,
          "#000000",
          "#FFFFFF",
          itemName
        );
      }

      this.textData = "";
    },

    async addCart() {
      console.log("clickCart");
      if (!this.$store.state.currentProduct) {
        return;
      }

      // 未編集項目がある場合は注意ダイアログ
      if (this.quantity != this.editedNum) {
        this.$store.commit("setYesNoDialogCallback", this.addCartProcess);
        this.$store.commit("showYesNoDialog", "未編集項目があります。\nよろしいですか？");
      } else {
        await this.addCartProcess();
      }
    },

    async addCartProcess() {
      // プログレスバーを表示
      this.$store.commit("showProgress");
      this.$store.commit("setProgressMessages", [
        "デザインデータを作成中…",
        "しばらくお待ちください",
      ]);

      await this.$store.state.draftManager
        .registDesign(this.$store.state.currentProduct, false, this.$store)
        .catch((e) => {
          this.$store.commit("hideProgress");
          this.$common.log(e);
          this.$store.commit("showMessage", "エラーが発生しました");
          return;
        });
      this.$store.commit("setProgress", 15);

      // プロダクトタイプが再編集になっている場合はカートの中のものを削除
      if (this.$store.state.currentProduct.cartId != "") {
        await this.$store.state.cartManager
          .delete(this.$store.state.currentProduct.cartId)
          .catch((e) => {
            this.$store.commit("hideProgress");
            this.$common.log(e);
            this.$store.commit("showMessage", "エラーが発生しました");
            return;
          });
      }

      let self = this;
      await this.$store.state.cartManager.addCartProduct(this.$store.state.currentProduct, false, function(progress){
        self.$store.commit("setProgress", 15 + (85 / 100 * progress));
      })
        .catch((e) => {
          this.$store.commit("hideProgress");
          this.$common.log(e);
          this.$store.commit("showMessage", "エラーが発生しました");
          return;
        });


      // 割引後の単価を計算
      const productPrice = GetAcryProductPrice(this.$store.state.currentProduct.productId);
      const totalQuantity = parseInt(this.$store.state.cartManager.getCartProductQuantity(this.$store.state.currentProduct.productId));
      const ratio = DiscountRatio(totalQuantity);
      // 丸め誤差が出ないようにライブラリを使用して計算
      const priceBase = new Big(productPrice.priceBase);
      const priceRatio = new Big(100-ratio).div(100);
      const discountPrice = priceBase.times(priceRatio);

      const productSizeTxt = GetAcryProductSizeText(this.$store.state.currentProduct.productId);
      Analytics.addToCartAcrylic(this.$store.state.currentProduct.productId, this.$store.state.currentProduct.productName, this.$store.state.currentProduct.quantity, discountPrice.toNumber(), productSizeTxt );

      this.$store.commit("hideProgress");
      this.$store.commit("showMessage", "カートに追加しました");

      // 表示を戻す
      this.$store.commit("setCenterViewState", CenterViewState.Upload);
      this.$store.commit("setRightViewState", RightViewState.Cart);
    },

    // 下書き保存
    async saveDraft() {
      if (!this.$store.state.currentProduct) {
        return;
      }

      this.$store.commit("showLoading");

      await this.$store.state.draftManager
        .registDesign(this.$store.state.currentProduct, true, this.$store)
        .catch((e) => {
          this.$store.commit("hideLoading");
          this.$common.log(e);
          this.$store.commit("showMessage", "エラーが発生しました");
          return;
        });

      if (this.$store.state.currentProduct.draftId != "") {
        await this.$store.state.draftManager
          .delete(this.$store.state.currentProduct.draftId)
          .catch((e) => {
            this.$store.commit("hideProgress");
            this.$common.log(e);
            this.$store.commit("showMessage", "エラーが発生しました");
            return;
          });
      }

      this.$store.commit("hideLoading");
      this.$store.commit("showMessage", "下書き保存しました");

      // 表示を戻す
      this.$store.commit("setCenterViewState", CenterViewState.Upload);
      this.$store.commit("setRightViewState", RightViewState.Cart);
    },

    browserEdit: function () {
      this.$store.commit("setListEditMode", true);
      // this.selectItemName = this.itemList;
    },
    endBrowserEdit: function () {
      this.$store.commit("setListEditMode", false);
    },
    csvExport: function () {
      if (!this.$store.state.currentCanvasData) {
        return;
      }

      const csv = new CSV();
      csv.exportData(
        this.$store.state.currentCanvasData.itemList,
        this.$store.state.currentProduct.quantity
      );

      // メタデータの設定
      // csv.pushMetadata("デザインID");
      // csv.pushMetadata("デザインID");

      // // ヘッダーを設定
      // csv.pushHeader("枚数");
      // this.$store.state.currentCanvasData.itemList.forEach((item, index)=>{
      //   csv.pushHeader("テキスト"+(index+1));
      // });

      // console.log("a")
      // console.log(this.$store.state.currentProduct.quantity)

      // for( let i = 0; i < this.$store.state.currentProduct.quantity; ++i ){
      //   csv.pushData((i+1)+"/"+this.$store.state.currentProduct.quantity);
      //   for( const item of this.$store.state.currentCanvasData.itemList ){
      //     csv.pushData(item.textArray[i].text);
      //   }
      //   // 最後の行以外は改行処理を入れる
      //   if( this.$store.state.currentProduct.quantity != (i-1) ){
      //     console.log("pushNextLine")
      //     csv.pushNextLine();
      //   }
      // }
      // csv.download();
    },
    async csvImport() {
      if (!this.$store.state.currentCanvasData) {
        return;
      }

      const file = this.$refs.design.files[0];
      const csv = new CSV();
      await csv.importFile(file);

      this.$store.state.currentCanvasData.itemList.forEach((element) => {
        let result = csv.getColData(element.itemName);
        if (result != null) {
          for (let i = 0; i < Math.min(element.textArray.length, result.length); ++i) {
            element.textArray[i] = result[i];
          }
        }
      });
    },
    tutorialNextStep(){
      if(this.$store.state.tutorial.editStep == 2){
        this.$store.commit("hideEditTutorial");
      }else{
        this.$store.commit("editTutorialNextStep");
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.btn-size{
  height:40px;
  width:275px;
  font-weight: bold;
}

.item-scroll {
  display: flex;
  flex-direction: column;
  // height: 630px;
  padding: 8px;
  gap: 8px;
  //overflow-y: scroll;
}

.list-scroll {
  display: flex;
  flex-direction: column;
  // height: 630px;
  gap: 8px;
  //overflow-y: scroll;
}

.menu-tab-text {
  font-size: 15px;
  margin: 10px;
}

.form-select{
  height: 40px;
  margin-top: 8px;
  margin-bottom: 8px;
  border: 1px solid $border-sub-color;
  background: $background-gray-color;
  border-radius: 0px;
}
.select-icon{
  position: absolute;
  top: 13px;
  right: 19px;
  height: 30px;
  width: 30px;
  pointer-events: none;
  background-image: url('~@/assets/acrypro/dropdown_icon.png');
}
.form-control{
  border-radius: 0px;
}

.input-text{
  height: 40px;
  width: 275px;

}

.input-text-icon{
  position: absolute;
  right: 16px;
}





.tab-border {
  width: 100%;
  height: 100%;
  border: 5px solid #848fb0;
  border-top: 0px;
  border-right: 0px;
  border-left: 0px;
}

.line {
  height: 2px;
  background-color: #e6e5eb;
}





.list-no-text {
}

.list-text-box {
}

.area-line {
  margin: 15px;
  height: 2px;
  background-color: #e6e5eb;
}

.select-box {
  /* width: 100%;
	padding: 10px;
	-webkit-appearance: none;
	-moz-appearance: none;
	appearance: none;
	border: 1px solid #999;
	background: #eee; */
  /* background: url(arrow01.png) right 50% no-repeat, -webkit-linear-gradient(top, #fff 0%,#efebe1 100%);
	background: url(arrow01.png) right 50% no-repeat, linear-gradient(to bottom, #fff 0%,#efebe1 100%); */
  /* background-size: 20px, 100%; */
}

input[type="file"] {
  display: none;
}

// .acry-btn {
//   margin: 10px;
//   padding: 3px 30px;
//   color: #000000;
//   border-color: #000000;
//   background-color: #ffffff;
//   border-radius: 15px;
//   font-size: 15px;
//   border: 0px;
// }

.csv-import {
  cursor: pointer;
}
.tutorial-modal{
  width: 800px;
  position: absolute;
  left: -830px;
  z-index: 3;
  background: white;
  border-radius: 4px;
}
.feature-ui{
  z-index: 3;
  pointer-events: none;
  background: white;
}
.addtext{
  border: 2px solid $primary-main-color;
}

.scrollbar {
  overflow-y: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.scrollbar::-webkit-scrollbar {
  display: none;
}
</style>
